import { WogaaService } from 'br2s-ui-common-utils-02';
export const handleStartWoGaaTransactions = (woGaaTransactionData) => {
    if (!woGaaTransactionData || woGaaTransactionData.length === 0) {
        return;
    }
    woGaaTransactionData.forEach((woGaa) => {
        WogaaService === null || WogaaService === void 0 ? void 0 : WogaaService.startTransaction(woGaa === null || woGaa === void 0 ? void 0 : woGaa.trackingId, woGaa === null || woGaa === void 0 ? void 0 : woGaa.transactionName);
    });
};
export const handleStopWoGaaTransaction = (woGaaTransactionData) => {
    woGaaTransactionData.forEach((woGaaTransaction) => {
        WogaaService === null || WogaaService === void 0 ? void 0 : WogaaService.completeTransaction((woGaaTransaction === null || woGaaTransaction === void 0 ? void 0 : woGaaTransaction.trackingId) || '', (woGaaTransaction === null || woGaaTransaction === void 0 ? void 0 : woGaaTransaction.transactionName) || '');
    });
};
